/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Links } from './Links';
import {
    LinksFromJSON,
    LinksFromJSONTyped,
    LinksToJSON,
} from './Links';
import type { TransactionsTransactionP2P } from './TransactionsTransactionP2P';
import {
    TransactionsTransactionP2PFromJSON,
    TransactionsTransactionP2PFromJSONTyped,
    TransactionsTransactionP2PToJSON,
} from './TransactionsTransactionP2P';

/**
 * 
 * @export
 * @interface GetPaymentDetailsOutput
 */
export interface GetPaymentDetailsOutput {
    /**
     * 
     * @type {TransactionsTransactionP2P}
     * @memberof GetPaymentDetailsOutput
     */
    transactions?: TransactionsTransactionP2P;
    /**
     * 
     * @type {Links}
     * @memberof GetPaymentDetailsOutput
     */
    links?: Links;
    /**
     * 
     * @type {Error}
     * @memberof GetPaymentDetailsOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the GetPaymentDetailsOutput interface.
 */
export function instanceOfGetPaymentDetailsOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetPaymentDetailsOutputFromJSON(json: any): GetPaymentDetailsOutput {
    return GetPaymentDetailsOutputFromJSONTyped(json, false);
}

export function GetPaymentDetailsOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPaymentDetailsOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transactions': !exists(json, 'transactions') ? undefined : TransactionsTransactionP2PFromJSON(json['transactions']),
        'links': !exists(json, '_links') ? undefined : LinksFromJSON(json['_links']),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function GetPaymentDetailsOutputToJSON(value?: GetPaymentDetailsOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transactions': TransactionsTransactionP2PToJSON(value.transactions),
        '_links': LinksToJSON(value.links),
        'error': value.error,
    };
}

